import { render } from "./SouvenirCreatorComponent.vue?vue&type=template&id=54603a05&scoped=true&ts=true"
import script from "./SouvenirCreatorComponent.vue?vue&type=script&lang=ts"
export * from "./SouvenirCreatorComponent.vue?vue&type=script&lang=ts"

import "./SouvenirCreatorComponent.vue?vue&type=style&index=0&id=54603a05&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54603a05"]])

export default __exports__